import { BarChart3, ClipboardList, Shield, Building2, Factory, Landmark, Truck } from 'lucide-react';

export const reportTabs = [
  { id: 'loadings', label: 'Погрузки', icon: BarChart3 },
  { id: 'requests', label: 'Заявки', icon: ClipboardList },
  { id: 'kpp', label: 'Охрана КПП', icon: Shield },
  { id: 'top', label: 'ТОП-базы', icon: Building2 },
  { id: 'chpp', label: 'ТЭЦ', icon: Factory },
  { id: 'private', label: 'Социальные объекты', icon: Landmark },
  { id: 'drivers', label: 'Транспорт', icon: Truck },
];
